var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 1.94043H1.75C1.61207 1.94043 1.50023 2.05255 1.5 2.19043V10.1904C1.5 10.3285 1.61193 10.4404 1.75 10.4404H9.75C9.88807 10.4404 10 10.3285 10 10.1904V6.19043H11.5V10.1904C11.5 11.1569 10.7165 11.9404 9.75 11.9404H1.75C0.783502 11.9404 0 11.1569 0 10.1904V2.19043C0.000230973 1.22413 0.783644 0.44043 1.75 0.44043H5.75V1.94043ZM8.35645 0.615234C9.17653 -0.20477 10.5061 -0.204816 11.3262 0.615234C12.146 1.4353 12.1461 2.76496 11.3262 3.58496L7.33105 7.58008L3.86621 8.0752L4.36133 4.61035L8.35645 0.615234ZM5.77539 5.31738L5.63379 6.30664L6.62402 6.16602L9.09863 3.69043L8.25 2.84277L5.77539 5.31738ZM10.2656 1.67578C10.0314 1.44152 9.65129 1.44156 9.41699 1.67578L9.31055 1.78223L10.1592 2.62988L10.2656 2.52441C10.4998 2.2902 10.4997 1.91006 10.2656 1.67578Z",
    fill: "#33333F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.ea06abe022c9d166726d120a814ea4fc.svg";
export { ForwardRef as ReactComponent };